/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { productService } from 'services'

const initialState = {
  isEligibleToBuy: false,
  isLoadingElegible: true,
  detailProduct: null,
}

const { getIsUserEligibleToBuy } = productService()

export const fetchIsEligibleToBuy = createAsyncThunk('contract/eligible', async contractId => {
  const { data } = await getIsUserEligibleToBuy({ contractId })

  return data
})

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    setDetailProduct: (state, action) => {
      state.detailProduct = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchIsEligibleToBuy.fulfilled, (state, action) => {
        const isEligible = action.payload.eligible

        state.isEligibleToBuy = isEligible
        state.isLoadingElegible = false
      })
      .addCase(fetchIsEligibleToBuy.rejected, state => {
        state.isEligibleToBuy = false
        state.isLoadingElegible = false
      })
  },
})

export const { setDetailProduct } = storeSlice.actions

export default storeSlice.reducer
